import React, { FunctionComponent, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';

// MUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Common
import api from '../../../../api';
import { GENERAL } from '../../../../constants';
import { models, types } from '../../../../types';

// Components
import { Tile } from '../../../Tile';
import { FormRadioGroup } from '../FormInputs';

interface ProfileFields {
    schoolLevel: any;
}

type TProps = {
    programs: types.TBaseDictionaryField | any;
}

const FormPrograms: FunctionComponent<TProps> = ({
    programs
}) => {
    const [ availablePrograms, setAvailablePrograms ] = useState(null);
    const [ availableProgramsError, setAvailableProgramsError ] = useState('');

    const { values: { schoolLevel }, setFieldValue } = useFormikContext<ProfileFields>();

    const fetchAvailablePrograms = (model: models.TProgram) => {
        api.getProgram(model)
            .then(({ data }) => {
                setAvailablePrograms(data.data);
            })
            .catch(error => {
                setAvailableProgramsError(error.message);
            });
    };

    useEffect(() => {
        if (!schoolLevel) {
            return;
        }
        const model: models.TProgram = {
            schoolLevel: schoolLevel,
        }
        fetchAvailablePrograms(model);
    }, [schoolLevel]);

    const handleChangeProgram = () => {
        setFieldValue('subjectId', '');
    };

    if (availableProgramsError) {
        return (
            <Typography
                variant="body2"
                color="error"
            >
                {availableProgramsError}
            </Typography>
        );
    }

    return (
        <Tile title={GENERAL.PROGRAMS_TITLE}>
            {!schoolLevel &&
                <Box>
                    <Typography
                        variant="body2"
                        color="error"
                        gutterBottom
                    >
                        {GENERAL.PROGRAMS_DESCRIPTION}
                    </Typography>
                </Box>
            }
            <Box>
                <Field
                    name="programId"
                    options={programs}
                    required
                    disabled={!schoolLevel}
                    disabledOptions={availablePrograms}
                    handleChange={handleChangeProgram}
                    component={FormRadioGroup}
                />
            </Box>
        </Tile>
    );
};

export default FormPrograms;
